import React from 'react';

import CarRentalContainer from '../CarRentalContainer';

const CarRentalContainerMobile = (props) => {
  const newProps = Object.assign({}, props, {
    skeletonType: 'SkeletonCarRentalContainerMobile',
  });
  return <CarRentalContainer {...newProps} />;
};

CarRentalContainerMobile.componentName = 'CarRentalContainerMobile';

CarRentalContainerMobile.propTypes = {};

CarRentalContainerMobile.defaultProps = {};

export default CarRentalContainerMobile;
